import React, { PureComponent } from 'react';
import _ from 'lodash';
import Thumbnail from './thumbnail/';
import Slider from './slider/';
import Player from './player/';
import { getImgByCardSize, getImgThumbUrl, getImgSrcSet } from './helpers';
import {trackTime} from '../../utils/tracking.js';
import './style.scss';
import PropTypes from 'prop-types';
import { withGigCardContext } from '../gig_card_context';

class Media extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            assets: null,
            loadedAssets: false,
            slideWidth: 230
        };

        this.loadAssets = this.loadAssets.bind(this);
        this.getGigItemWidth = _.debounce(this.getGigItemWidth, 250).bind(this);
        this.startTime = Date.now();
    }

    componentWillMount() {
        const assets = this.props.assets;

        this.setState({
            assets
        });

        trackTime('media-component-will-mount', this.startTime, this.props.cardType);
    }

    componentDidMount() {
        window.addEventListener('resize', this.getGigItemWidth);
        this.getGigItemWidth();

        trackTime('media-component-did-mount', this.startTime, this.props.cardType);
    }

    componentWillReceiveProps(next) {
        if (next.assets && (this.state.assets.length < next.assets.length)) {
            const assets = next.assets;

            this.setState({
                assets
            });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.getGigItemWidth);
    }

    getGigItemWidth() {
        let running = false;

        if (!running) {
            running = true;
            window.requestAnimationFrame(() => this.setSlideWidth(() => running = false));
        }
    }

    setSlideWidth(callback) {
        this.setState((state) => {
            const containerWidth = this.mediaContainer.offsetWidth;
            let nextState = state;

            if (containerWidth && state.slideWidth !== containerWidth) {
                nextState = Object.assign({}, state, { slideWidth: containerWidth });
            }

            return nextState;
        }, callback);
    }

    loadAssets() {
        if (this.state.loadedAssets) {
            return;
        }

        const assets = this.state.assets.map((asset) => Object.assign({}, asset, { visible: true }));

        this.setState({
            assets,
            loadedAssets: true
        });
    }

    render() {
        const {assets, slideWidth} = this.state,
            { userId, gigId, cardType, cardSize, shouldLoad } = this.props;

        if (!assets) {
            return null;
        }

        return (
            <div className="media-container" ref={(el) => this.mediaContainer = el} onMouseEnter={this.loadAssets}>
                {shouldLoad && <Slider slideWidth={slideWidth} gigId={gigId} cardType={cardType} cardSize={cardSize}>
                    {assets.map((asset, index) => (
                        (index === 0 || asset.visible) && asset.asset_type === 'image' && <div key={`wrapper-${index}-${gigId}`} style={{'width': `${slideWidth}px`}}><Thumbnail key={`thumb-${index}-${gigId}`} shouldLoad={shouldLoad} src={getImgThumbUrl(getImgByCardSize(asset.image_data, cardSize))} srcSet={getImgSrcSet(getImgByCardSize(asset.image_data, cardSize))} cardType={cardType} cardSize={cardSize}/></div> ||
                        ((index === 0 || asset.visible) && asset.asset_type === 'video' || asset.asset_type === 'audio') && <div key={`wrapper-${index}-${gigId}`} style={{ 'width': `${slideWidth}px` }}><Player key={`player-${index}-${gigId}`} shouldLoad={shouldLoad} media={asset} gigId={gigId} cardType={cardType} cardSize={cardSize} userId={userId}/></div>
                    ))}
                </Slider>}
            </div>
        );
    }
}

Media.propTypes = {
    assets: PropTypes.array,
    gigId: PropTypes.number,
    cardType: PropTypes.string
};

const contextSelector = ({ cardType, cardSize }) => ({ cardType, cardSize });

export default withGigCardContext(contextSelector)(Media);
export { Media as UnwrappedMedia };



// WEBPACK FOOTER //
// ./src/shared/media/index.js